import * as React from "react";

function NutexIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 90 28"
    >
      <defs>
        <clipPath>
          <rect width="90" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-nutex)">
        <path
          data-name="Path 7121"
          d="M-39.435,0V-18.611h3.656l7.617,12.429V-18.611h3.491V0h-3.771l-7.5-12.137V0Zm28.887,0V-2.019a5.2,5.2,0,0,1-1.936,1.7A5.427,5.427,0,0,1-15.017.3a4.952,4.952,0,0,1-2.437-.6,3.523,3.523,0,0,1-1.562-1.676A7.478,7.478,0,0,1-19.5-4.951v-8.531h3.567v6.2a17.18,17.18,0,0,0,.2,3.485,1.9,1.9,0,0,0,.717,1.016,2.2,2.2,0,0,0,1.32.375,2.807,2.807,0,0,0,1.638-.5,2.551,2.551,0,0,0,.99-1.244A14.441,14.441,0,0,0-10.8-7.795v-5.687h3.567V0ZM1.974,0V-15.463H-3.548v-3.148h14.79v3.148H5.732V0ZM20.819-4.291l3.555.6A5.831,5.831,0,0,1,22.209-.717,6.359,6.359,0,0,1,18.508.3a6.032,6.032,0,0,1-5.205-2.3A7.72,7.72,0,0,1,11.97-6.64a7.444,7.444,0,0,1,1.752-5.25,5.77,5.77,0,0,1,4.431-1.9A5.985,5.985,0,0,1,22.9-11.8q1.739,1.987,1.663,6.087H15.627a3.609,3.609,0,0,0,.863,2.469,2.7,2.7,0,0,0,2.057.882,2.184,2.184,0,0,0,1.409-.457A2.822,2.822,0,0,0,20.819-4.291Zm.2-3.605a3.435,3.435,0,0,0-.8-2.355,2.454,2.454,0,0,0-1.854-.806,2.478,2.478,0,0,0-1.93.851A3.291,3.291,0,0,0,15.69-7.9ZM27.058,0,31.92-6.944l-4.659-6.538h4.354L34-9.775l2.514-3.707H40.7L36.135-7.1,41.124,0h-4.38L34-4.177,31.234,0Z"
          transform="translate(45 23)"
          fill="#206dfd"
          stroke="#1c1c1c"
          stroke-width="1"
        />
      </g>
    </svg>
  );
}

export default NutexIcon;
